import { render, staticRenderFns } from "./MagicOrgChartDemo.vue?vue&type=template&id=78f9f784&scoped=true&"
import script from "./MagicOrgChartDemo.vue?vue&type=script&lang=js&"
export * from "./MagicOrgChartDemo.vue?vue&type=script&lang=js&"
import style0 from "./MagicOrgChartDemo.vue?vue&type=style&index=0&id=78f9f784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f9f784",
  null
  
)

export default component.exports